import APP from "constants/applications";
import { TIER } from "constants/tier";

import { ACCOUNT_TYPES } from "./constants";

export function computeDefaultType(entry) {
  switch (entry) {
    case APP.BUSINESS:
      return ACCOUNT_TYPES.BUSINESS;
    case APP.ADMIN:
      return ACCOUNT_TYPES.ADMIN;
    case APP.TITLE_AGENCY:
      return ACCOUNT_TYPES.TITLE_AGENCY;
    case APP.LENDER:
      return ACCOUNT_TYPES.LENDER;
    case APP.NOTARY:
      return ACCOUNT_TYPES.NOTARY;
    case APP.CUSTOMER:
      return ACCOUNT_TYPES.PERSONAL;
    default:
      return ACCOUNT_TYPES.PERSONAL;
  }
}

/** @type {(entry: string | null, userAccountTypes: string[]) => string[]} */
export function getTargetAppAccountTypes(entry, userAccountTypes) {
  // The target app account types are ordered
  const rank = Object.freeze({
    [ACCOUNT_TYPES.LENDER]: 0,
    [ACCOUNT_TYPES.TITLE_AGENCY]: 1,
    [ACCOUNT_TYPES.BUSINESS]: 2,
    [ACCOUNT_TYPES.REALTOR]: 2,
    [ACCOUNT_TYPES.BROKER]: 2,
    [ACCOUNT_TYPES.NOTARY_MARKETPLACE]: 2,
    [APP.BUSINESS]: 2,
    [ACCOUNT_TYPES.PERSONAL]: 3,
    [ACCOUNT_TYPES.ADMIN]: 4,
    [ACCOUNT_TYPES.NOTARY]: 5,
  });

  userAccountTypes = (userAccountTypes || []).map((accountType) => accountType.toLowerCase());

  userAccountTypes.sort((a, b) => {
    if (a === entry) {
      return -1;
    } else if (b === entry) {
      return 1;
    } else if (rank[a] < rank[b]) {
      return -1;
    }

    return 1;
  });

  return userAccountTypes.length ? userAccountTypes : [entry];
}

export function canLoginWithGoogle({ tier, selectedAccount }) {
  return tier !== TIER.PRO_TRIAL && selectedAccount !== APP.TITLE_AGENCY;
}
